import "@styles/layouts.scss";
import { Div, Image } from "@components/Generics.react";
import { lightStyle } from "@utilities/helpers";
import { settings } from "../config/settings/app.settings";

export default function PreviewLayout(props) {
    const { url = "/", message } = props;
    // ========================= Render Function =================================
    return (
        <Div
            minWd="400px"
            wd="400px"
            fullht
            maxHt="calc(100vh - 75px)"
            relative
            padSides
            noOverflow
        >
            <Div absolute fluid fullht padRight noOverflow>
                <Image fluid src="/assets/images/mobile.png" />
            </Div>
            <Div
                absolute
                style={{
                    ...lightStyle(settings.colors.primary),
                    top: "44px",
                    left: "34px",
                    width: "334px",
                    height: "calc(100vh - 120px)",
                    maxHeight: "668px",
                    borderRadius: "10px",
                }}
                noOverflow
            >
                <iframe
                    className="iframe-container"
                    title="Preview Wrapper"
                    src={`${url}?preview=true`}
                    width={"265px"}
                    height={"525px"}
                    style={{ border: 0 }}
                />
                {message && (
                    <Div fluid style={{ marginTop: "-65px" }}>
                        <Div padded peat wd="80%" center-align centered>
                            {message}
                        </Div>
                    </Div>
                )}
            </Div>
        </Div>
    );
}
